import React, { Fragment, useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function Usps() {
  const {
    car,
  } = useContext(CarOrderingContext)

  const usps = car?.usps ?? []

  if (usps.length < 1) {
    return null
  }

  return (
    <div className='car-usps'>
      {usps.map((usp, index) => (
        <Fragment key={index}>
          <aside className='usp car-usps__usp'>
            {typeof usp?.url === 'string' && (
              <div className='car-usps__icon-wrap'>
                <img src={usp.url} alt={typeof usp?.alt === 'string' ? usp.alt : null}/>
              </div>
            )}

            <div className='car-usps__text-wrap'>
              <span className='value car-usps__title' dangerouslySetInnerHTML={{ __html: usp.title }}/>
              <span className='title car-usps__text'>{usp.text}</span>
            </div>
          </aside>

          {index < usps.length - 1 && (<span className='car-usps__seperator'/>)}
        </Fragment>
      ))}
    </div>
  )
}
